module.exports = __webpack_public_path__ + "static/media/image-card-7.2488b141.png";